module.exports = __webpack_public_path__ + "static/media/fruits_37.09f84de9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_37.csv
// module id = 703
// module chunks = 0